const Colors = {
  white: '#ffffff',
  blue: '#298bfe',
  red: '#e72d2d',
  lightPurple: '#9499c3',
  black: '#1a1c48',
  yellow: '#ffd630',
  green: '#40c110',
  fpink: '#f72585',
  fdarkblue: '#3a0ca3',
  fviolet: '#7209b7',
  fblue: '#4361ee',
  flightblue: '#4cc9f0'
};

export default Colors;